"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.environmentUrls = exports.urlToEnvironment = void 0;
var core_1 = require("@attensi/core");
var environmentUrlCollection = {
    adminView: {
        production: 'https://admin.attensi.com',
        staging: 'https://admin-staging.attensi.com',
    },
    backend: {
        production: 'https://api.attensi.com',
        staging: 'https://api-staging.attensi.com',
    },
    creatorServer: {
        production: 'https://creator-server.attensi.com',
        staging: 'https://creator-server-staging.attensi.com',
    },
    localizedText: {
        production: 'https://localized-text.attensi.com',
        staging: 'https://localized-text-staging.attensi.com',
    },
    loginService: {
        production: 'https://login.attensi.com',
        staging: 'https://login-staging.attensi.com',
    },
    portal: {
        production: 'https://portal.attensi.com',
        staging: 'https://portal-staging.attensi.com',
    },
};
var getUrl = function (url, environment) {
    if (environment === core_1.AttensiEnvironment.STAGING) {
        return url.staging;
    }
    return url.production;
};
/**
 * Returns Environment based on URL and Service
 * Defaults to DEVELOPMENT
 */
exports.urlToEnvironment = function (url, service) {
    var serviceUrls = environmentUrlCollection[service];
    if (url.match(serviceUrls.production)) {
        return core_1.AttensiEnvironment.PRODUCTION;
    }
    if (url.match(serviceUrls.staging)) {
        return core_1.AttensiEnvironment.STAGING;
    }
    return core_1.AttensiEnvironment.DEVELOPMENT;
};
exports.environmentUrls = {
    adminView: function (environment) {
        return getUrl(environmentUrlCollection.adminView, environment);
    },
    backend: function (environment) {
        return getUrl(environmentUrlCollection.backend, environment);
    },
    creatorServer: function (environment) {
        return getUrl(environmentUrlCollection.creatorServer, environment);
    },
    localizedText: function (environment) {
        return getUrl(environmentUrlCollection.localizedText, environment);
    },
    loginService: function (environment) {
        return getUrl(environmentUrlCollection.loginService, environment);
    },
    portal: function (environment) {
        return getUrl(environmentUrlCollection.portal, environment);
    },
};
//# sourceMappingURL=environmentUrls.js.map